if (!customElements.get('promotion-expiry')) {
    class PromotionExpiry extends HTMLElement {
        #intervalId = null;

        connectedCallback() {
            this.elTime = this.querySelector('.promotion-expiry--time');
            this.expiry = Number(this.dataset.expiry) * 1000;

            if (!this.elTime || !this.expiry) {
                return;
            }

            this.#tick();
            this.#intervalId = setInterval(() => this.#tick(), 1000);
        }

        disconnectedCallback() {
            clearInterval(this.#intervalId);
        }

        #tick() {
            const remaining = this.expiry - Date.now();

            if (remaining <= 0) {
                this.#onExpired();
                return;
            }

            this.elTime.textContent = this.#format(remaining);
        }

        #onExpired() {
            clearInterval(this.#intervalId);

            if (this.elTime) {
                this.elTime.hidden = true;
            }

            const label = this.querySelector('.promotion-expiry--label');

            if (label) {
                label.remove();
            }

            const cta = this.querySelector('.promotion-expiry--cta');
            const hasCtaContent =
                cta &&
                (cta.children.length > 0 || cta.textContent.trim().length > 0);

            if (!hasCtaContent) {
                this.hidden = true;
            }
        }

        #format(ms) {
            const totalSeconds = Math.floor(ms / 1000);
            const days = Math.floor(totalSeconds / 86400);
            const hours = Math.floor((totalSeconds % 86400) / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;

            const pad = (value) => String(value).padStart(2, '0');
            const time = [pad(hours), pad(minutes), pad(seconds)].join(':');

            if (days > 0) {
                return `${pad(days)}:${time}`;
            }

            return time;
        }
    }

    customElements.define('promotion-expiry', PromotionExpiry);
}
